import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

interface UpdateBigQueryPayload {
  filters: {
    identifier: string;
  };
  update_data: Record<string, string>;
  request_id?: string;
}

/**
 * POSTs a row update to the commons BigQuery update endpoint.
 *
 * @param payload - `filters` (e.g. `identifier`) and `update_data` column / JSON path updates
 * @returns Parsed JSON body from the API
 * @throws {Error} When auth is missing, HTTP status is not OK, or the body reports `success: false`
 */
export const updateBigQueryData = async (payload: UpdateBigQueryPayload) => {
  try {
    const token = await getBearerToken();
    if (!token) {
      throw new Error("Bearer token not available");
    }

    const response = await fetch(API_ENDPOINTS.UPDATE_BIGQUERY_DATA, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    if (data && typeof data.success === "boolean" && !data.success) {
      throw new Error(data.message || "BigQuery update was not successful");
    }
    return data;
  } catch (error) {
    console.error("Error updating BigQuery data:", error);
    throw error;
  }
};
